import { createFileRoute } from '@tanstack/react-router';

import { HomeworkPage } from '@/features/student/HomeworkPage';
import { requireRole } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/homework')({
  beforeLoad: () => requireRole('student'),
  component: HomeworkPage,
});
